import React from 'react';
import { Award, Heart, Shield, Clock, Stethoscope } from 'lucide-react';

const AboutSection = () => {
  return (
    <section id="about" className="section-padding bg-page">
      <div className="container">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div className="order-2 md:order-1">
            <h2 className="heading-1 mb-6">
              Meet Dr Ismail M. Meer
            </h2>
            
            <p className="body-large mb-6">
              A dedicated medical professional committed to providing holistic, patient-centered, quality care at your convenience.<br />
              With comprehensive training and genuine compassion, <span style={{ whiteSpace: 'nowrap' }}>Dr Meer</span> brings expert healthcare directly to you.
            </p>

            <div className="space-y-4 mb-8">
              <div className="qualification-item">
                <Award className="text-medical-red" size={20} />
                <div>
                  <div className="heading-3">Bachelor of Medicine, Bachelor of Surgery (MBBS)</div>
                  <div className="body-small">Comprehensive Medical Training</div>
                </div>
              </div>
              
              <div className="qualification-item">
                <Shield className="text-medical-red" size={20} />
                <div>
                  <div className="heading-3">Independent Practitioner - HPCSA Registered</div>
                  <div className="body-small">Practice Number: 1182064</div>
                </div>
              </div>
              
              <div className="qualification-item">
                <Stethoscope className="text-medical-red" size={20} />
                <div>
                  <div className="heading-3">General Practitioner</div>
                  <div className="body-small">Providing comprehensive primary healthcare services</div>
                </div>
              </div>
              
              <div className="qualification-item">
                <Heart className="text-medical-red" size={20} />
                <div>
                  <div className="heading-3">Dispensing Licence Registered</div>
                  <div className="body-small">Authorised to provide personalised medication packages</div>
                </div>
              </div>
            </div>

            <div className="p-6 rounded-lg" style={{ backgroundColor: 'rgba(196, 30, 58, 0.1)' }}>
              <div style={{ 
                display: 'inline-block', 
                backgroundColor: 'rgba(196, 30, 58, 0.85)', 
                color: 'white', 
                padding: '0.5rem 1.5rem', 
                borderRadius: '2rem',
                marginBottom: '1rem',
                fontSize: '1.1rem',
                fontWeight: '600'
              }}>
                Our Commitment
              </div>
              <p className="body-medium">
                To provide a broad spectrum of medical services, ensuring care tailored to individual needs. Every consultation includes personalised attention, detailed assessment as well as treatment plans designed specifically for your wellbeing.
              </p>
            </div>
          </div>

          <div className="order-1 md:order-2">
            <div className="doctor-image-container">
              <img 
                src="https://customer-assets.emergentagent.com/job_mobile-medcare/artifacts/hw5ey1nd_liftapp.png"
                alt="Dr Ismail M. Meer"
                className="doctor-image"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
